import styles from "./Service.module.scss"

import ImagePlaceHolderPng from "../assets/images/Image_Placeholder.png"
import servicePng from "../assets/images/service.png";
import readMorePng from "../assets/images/readmore.png"
import bgWhyUs from "../assets/images/bg_wu.png"
import bgMeetJennyPng from "../assets/images/bg__mjl.png"
import PhonePng from "../assets/images/Phone.png"
import WechatLogoPng from "../assets/images/WechatLogo.png"
import EnvelopeSimplePng from "../assets/images/EnvelopeSimple.png"
import MapPinPng from "../assets/images/MapPin.png"
import footerLogoPng from "../assets/images/foot_logo.png"
import logoPng from "../assets/images/logo.png"
import welcome1Png from "../assets/images/bg_p1.png"
import serviceBg1 from "./assets/image/service_bg1.png"
import serviceBg2 from "./assets/image/service_bg2.png"
import { useLoaderData, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import services, { ServiceDTO } from "./services";
import Header from "../components/header/Header";

export default () => {

    const params = useLoaderData()

    const getService = () => {
        return services[(params as any)['service']]
    }

    useEffect(() => {
        console.log("params: ", params)
        document.scrollingElement?.scrollTo({top: 0, behavior: "smooth"})
    }, [params])

    return (
        <div className={styles['homepage']}>
            <Header activateIdx={1}/>
            <Welcome service={getService()}/>
            <Introduce service={getService()}/>
            <CreateYourAccount/>
            <Footer/>
        </div>
    )

}


const Welcome = (props: {service: ServiceDTO}) => {

    const {
        service
    } = props
    return (
        <div className={styles['welcome__p1']}>
            <img src={serviceBg1} className={styles['welcome__p1__bg']}/>
            <div className={styles['welcome__p1__box']}>
                <div className={styles['welcome__p1__label']}>
                Service
                </div>
                <div className={styles['welcome__p1__title']}>
                    {service.title}
                </div>
                
            </div>
        </div>
    )

}



const Introduce = (props: {service: ServiceDTO}) => {

    const {
        service
    } = props

    return (
        <div className={styles["introduce"]}>
            <div className={styles['introduce__title']}>
                <div className={styles['introduce__title__main']}>{service.title}</div>
                <div className={styles['introduce__title__content']}>{service.content}</div>
            </div>
            <img className={styles['introduce__bg']} src={serviceBg2}></img>
        </div>
    )
}


const CreateYourAccount = () => {

    return (
        <div className={styles['cya']}>
            <div className={styles['cya__title']}>Start your immigration journey with our experts today!</div>
            <div className={styles['cya__action']}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['cya__action__a']}>Schedule A Consultation</a></div>
        </div>
    )
}

const Footer = () => {
    const navigate = useNavigate()
    return (
            <div className={styles['footer']}>
                <img className={styles['footer__logo']} src={footerLogoPng}></img>
                <div className={styles['footer__content']}>
                    <div className={styles['footer__contacts']}>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={MapPinPng}></img>
                            <div className={styles['footer__contact__title']}>1401 Mission Street, Ste C-1, South Pasadena, CA, 91030</div>
                        </div>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={EnvelopeSimplePng}></img>
                            <div className={styles['footer__contact__title']}>jenny.liu@excelluslaw.com</div>
                        </div>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={WechatLogoPng}></img>
                            <div className={styles['footer__contact__title']}>excelluslaw</div>
                        </div>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={PhonePng}></img>
                            <div className={styles['footer__contact__title']}>001-626-362-0721</div>
                        </div>

                    </div>
                    <div className={styles['footer__navs']}>
                        <div className={styles['footer__navs__title']}>Page</div>
                        <div className={styles['footer__navs__content']}>
                            <div className={[styles['footer__nav']].join(" ")} onClick={() => navigate("/")}>Home</div>
                            <div className={[styles['footer__nav']].join(" ")} onClick={() => navigate("/service/0")}>Service</div>
                            <div className={[styles['footer__nav']].join(" ")}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['footer__nav__a']}>Contact us</a></div>
                        </div>
                    </div>
                </div>
            </div>
        )
}